<div class="section bgi" style="background-image: url('../../assets/img/bg.jpg');">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="blog">
                   <app-header></app-header>
                    <app-section></app-section>
                    <app-footer></app-footer>
                </div>
            </div>
        </div>
    </div>
</div>